import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import { TYPES } from './constants';
import getIconType from './helpers/get-icon-type';
const SolidIcon = ({ glyph, type = TYPES.default, size = 24, strokeWidth = 1.3 }) => {
  const classes = classNames('ws-ui-solid-icon', `ws-ui-solid-icon--${type}`);
  const iconType = getIconType(type);

  return (
    <div className={classes}>
      <Icon glyph={glyph} type={iconType} size={size} strokeWidth={strokeWidth} />
    </div>
  );
};

export default SolidIcon;
